import classNames from "clsx";

type DividerProps = {
	dividerClassName?: string;
};

export function Divider({ dividerClassName }: DividerProps) {
	return (
		<div
			className={classNames("border-top-dotted border-gray-300 py-2", dividerClassName)}
		></div>
	);
}
